import { render, staticRenderFns } from "./timeLimit.vue?vue&type=template&id=de3bc9be&scoped=true"
import script from "./timeLimit.vue?vue&type=script&lang=js"
export * from "./timeLimit.vue?vue&type=script&lang=js"
import style0 from "./timeLimit.vue?vue&type=style&index=0&id=de3bc9be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3bc9be",
  null
  
)

export default component.exports